import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CalendarHeader from '../CalendarHeader';
import Loading from '../Loading';

import { loadCalendarEvents } from '../../../actions/events';
import { setFoodTicketsData } from '../../../actions/foodTickets';

const getDate = (date, monthStatus) => {
  const fromDate = new Date(date);
  const monthSelected = monthStatus === 'prev' ? -1 : 1;

  fromDate.setMonth(fromDate.getMonth() + monthSelected);

  const toDate = new Date(fromDate);

  toDate.setMonth(toDate.getMonth() + 1);

  return {
    fromDate,
    toDate
  };
};

class EventsCalendarHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  navigateToMonth = (_, fromDate, toDate) => {
    const {
      isFoodTickets,
      setFoodTicketsDataHandler,
      loadEvents,
      onNavigate
    } = this.props;

    this.setState({ loading: isFoodTickets });

    if (isFoodTickets) {
      setFoodTicketsDataHandler(
        fromDate.getMonth(),
        fromDate.getFullYear()
      ).then(() => {
        this.setState({ loading: false });
      });
    } else {
      loadEvents(fromDate, toDate).then(() => {
        this.setState({ loading: false });
      });
    }

    onNavigate(_, fromDate);
    this.setState({ loading: false });
  };

  render() {
    const { label, date, showNavigators } = this.props;

    return (
      <div>
        {this.state.loading ? (
          <Loading />
        ) : (
          <CalendarHeader
            id="calendar-header"
            month={label.split(' ')[0]}
            year={label.split(' ')[1]}
            showNavigators={showNavigators}
            onLeftClick={_ => {
              const { fromDate, toDate } = getDate(date, 'prev');
              this.navigateToMonth(_, fromDate, toDate);
              this.setState({ loading: false });
            }}
            onRightClick={_ => {
              const { fromDate, toDate } = getDate(date, 'next');
              this.navigateToMonth(_, fromDate, toDate);
            }}
          />
        )}
      </div>
    );
  }
}

EventsCalendarHeader.propTypes = {
  label: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  onNavigate: PropTypes.func,
  loadEvents: PropTypes.func,
  setFoodTicketsDataHandler: PropTypes.func,
  showNavigators: PropTypes.bool,
  isFoodTickets: PropTypes.bool
};

const mapStateToProps = ({ events, foodTickets }) => ({
  showNavigators: events.showNavigators,
  isFoodTickets: foodTickets.isFoodTickets
});

const mapDispatchToProps = dispatch => ({
  setFoodTicketsDataHandler: (month, year) =>
    setFoodTicketsData(dispatch, month, year),
  loadEvents: (fromDate, toDate, newDate) =>
    loadCalendarEvents(dispatch, fromDate, toDate, null, newDate)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsCalendarHeader);
